import { timer } from 'rxjs'
import { mergeMap } from 'rxjs/operators'
import { defineComponent } from 'vue'

import { Featured } from '@skinsoft/types'
import { reactiveVueMixin } from '@skinsoft/reactive-vue'
import { FeaturedCard } from '../featured-card'

export const EntityFeaturedCard = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sFeaturedCard: FeaturedCard,
    },
    props: ['entityDataStore', 'id', 'serializer', 'state'],
    template: require('./entity-featured-card.html'),
    data() {
        return {
            featured: null as Featured | null,
        }
    },
    created() {
        if (this.id) {
            this.subscribe();
        }
    },
    methods: {
        subscribe() {
            this.subscribeTo(
                this.entityDataStore.fetchOne(this.id).pipe(mergeMap(this.serializer)),
                featured => {
                    this.featured = featured;
                },
                'featured',
            );
        },
        unsubscribe() {
            this.unsubscribeFrom('featured');
        },
    },
    watch: {
        entityDataStore() {
            this.unsubscribe();
            this.subscribe();
        },
        id(id: string) {
            this.unsubscribe();
            this.subscribe();
        },
        state() {
            this.unsubscribe()
            timer(200).subscribe(this.subscribe)
        },
    },
})
